export default "__VITE_ASSET__CfFx3l$y__"